import {
	GET_CATEGORIES, CREATE_CATEGORIES, UPDATE_CATEGORIES, SET_MESSAGE, GET_ERRORS, DEACTIVATE_CATEGORIES, ACTIVATE_CATEGORIES
} from "../actions/types";

const initialState = {
	actionType: '',
	categories: [],
	error: '',
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_CATEGORIES:
			return {
				...state,
				actionType: action.type
			};
		case UPDATE_CATEGORIES:
			return {
				...state,
				actionType: action.type
			};
		case GET_CATEGORIES:
			return {
				...state,
				actionType: action.type,
				categories: action.payload.message
			};
		case DEACTIVATE_CATEGORIES:
			return {
				...state,
				actionType: action.type
			};
		case ACTIVATE_CATEGORIES:
			return {
				...state,
				actionType: action.type
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload

			};

		case SET_MESSAGE:
			return {
				...state,
				actionType: action.type,
				success: action.payload.message
			};

		default:
			return state;
	}
}